import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import {
  Button, Table, TableBody, TableCell, TableHead, TableRow, TableContainer,
  Paper, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Box,
  Typography, Grid, FormControlLabel, Checkbox,
} from '@mui/material';
import axios, { decryptData } from '../Axiosinstance';
import './Manage.css';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify'; // Import ToastContainer
import 'react-toastify/dist/ReactToastify.css';
import DownloadIcon from '@mui/icons-material/Download';
import { buttonBackgroundColor } from '../common';

const modulesData = [
  { moduleName: '', marks: { mark1: '', mark2: '', total: '' } },
  { moduleName: '', marks: { mark1: '', mark2: '', total: '' } },
  { moduleName: '', marks: { mark1: '', mark2: '', total: '' } },
  { moduleName: '', marks: { mark1: '', mark2: '', total: '' } },
  { moduleName: '', marks: { mark1: '', mark2: '', total: '' } },
  { moduleName: '', marks: { mark1: '', mark2: '', total: '' } }
];


const EditModuleModal = ({ open, onClose, currentMarks, handleEditChange, handleEditSubmit, showBothFields }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Edit Module Marks</DialogTitle>
    <DialogContent>
      {currentMarks && currentMarks.length > 0 && (
        <Box>
          {/* Always render mark1 */}
          <TextField
            type="number"
            label='M[50]' // Label for mark1
            variant="outlined"
            fullWidth
            value={currentMarks[0].marks.mark1}
            onChange={(e) => handleEditChange('mark1', e.target.value)}
            margin="normal"
          />
          {/* Render mark2 only if showBothFields is true */}
          {showBothFields && (
            <TextField
              type="number"
              label='A' // Label for mark2
              variant="outlined"
              fullWidth
              value={currentMarks[0].marks.mark2}
              onChange={(e) => handleEditChange('mark2', e.target.value)}
              margin="normal"
            />
          )}
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
      <Button onClick={handleEditSubmit} color="primary">Save</Button>
    </DialogActions>
  </Dialog>
);


const ModuleFormWithAssignment = ({ modules, handleInputChange, handleEdit, handleModuleSubmit }) => (
  <Grid container spacing={2}>
    {modules.map((module, moduleIndex) => (
      <Grid item xs={12} sm={6} md={4} key={moduleIndex}>
        <Box>
          <Typography variant="h6" gutterBottom noWrap sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {module.moduleName}
          </Typography>
          {['mark1', 'mark2', 'total'].map((key, idx) => (
            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <TextField
                type="number"
                label={key === 'mark1' ? `M[50] for ${module.moduleName}` :
                  key === 'mark2' ? `A for ${module.moduleName}` :
                    `Total for ${module.moduleName}`}
                variant="outlined"
                fullWidth
                value={module.marks[key]}
                onChange={(e) => handleInputChange(moduleIndex, key, e.target.value)}
                placeholder={key === 'total' ? 'Total' : 'Enter mark'}
                disabled={key !== 'total' && module.disabled}
                sx={{ flex: 1, minWidth: 0 }}

              />
            </Box>
          ))}
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => handleEdit(moduleIndex)}
            disabled={!module.hasMarks}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleModuleSubmit(moduleIndex)}
            // disabled={ module.isSubmitted || module.marks.mark1 === '0' || module.marks.mark2 === '0'|| module.hasMarks}
            disabled={module.isSubmitted || module.hasMarks}
          >
            Submit
          </Button>
        </Box>
      </Grid>
    ))}
  </Grid>
);



const ModuleFormWithoutAssignment = ({ modules, handleInputChange, handleEdit, handleModuleSubmit }) => (
  <Grid container spacing={2}>
    {modules.map((module, moduleIndex) => (
      <Grid item xs={12} sm={6} md={4} key={moduleIndex}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="h6" gutterBottom noWrap sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {module.moduleName}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <TextField
              type="number"
              label={`Mark for ${module.moduleName}`}
              variant="outlined"
              fullWidth
              value={module.marks.mark1}
              onChange={(e) => handleInputChange(moduleIndex, 'mark1', e.target.value)}
              placeholder='Enter mark'
              sx={{ flex: 1, minWidth: 0 }}
              // disabled={module.disabled}
              // disabled={ module.isSubmitted || module.marks.mark1 === '0' || module.hasMarks}
              disabled={module.isSubmitted || module.hasMarks}
            />
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}> {/* Add gap for spacing between buttons */}
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => handleEdit(moduleIndex)}
              disabled={!module.hasMarks}
            >
              Edit
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleModuleSubmit(moduleIndex)} // Call for the specific module
              disabled={!module.isEdited || module.isSubmitted} // Disable if not edited or already submitted
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Grid>
    ))}
  </Grid>
);



const ModuleForm = ({ open, onClose, studentId, assignment, studentData, fetchDataFromAPI }) => {
  // console.log("hida", studentId);
  const [modules, setModules] = useState([]);
  const { batchId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId));
  const [editOpen, setEditOpen] = useState(false);
  const [currentMarks, setCurrentMarks] = useState(null);
  const [currentModuleIndex, setCurrentModuleIndex] = useState(null); // Store current module index for editing

  const handleEdit = (moduleIndex) => {
    setCurrentModuleIndex(moduleIndex);
    setCurrentMarks([modules[moduleIndex]]); // Set only the current module for editing
    setEditOpen(true);
  };

  const handleEditChange = (key, value) => {
    const updatedMarks = [...currentMarks];
    updatedMarks[0].marks[key] = value; // Update the first (and only) module
    setCurrentMarks(updatedMarks);
  };

  const handleEditSubmit = async () => {

    const mark1 = currentMarks[0].marks.mark1;
    const mark2 = currentMarks[0].marks.mark2;

    if (!mark1) {
      toast.error("Please enter marks.");
      return;
    }

    if (assignment && !mark2) {
      toast.error("Please enter marks.");
      return;
    }


    const updatedModules = [...modules];
    updatedModules[currentModuleIndex] = currentMarks[0]; // Update the specific module

    const total = calculateTotal(currentMarks[0].marks);
    updatedModules[currentModuleIndex].marks.total = total;
    updatedModules[currentModuleIndex].isEdited = true; // Mark this module as edited
    updatedModules[currentModuleIndex].isSubmitted = false; // Set as not yet submitted

    try {
      const { moduleName, marks } = currentMarks[0];

      const response = await axios.put(`registrationadvances/marks/${studentId}/moduleMarks1`, [
        {
          moduleName,
          mark1: parseFloat(marks.mark1) || 0,
          mark2: parseFloat(marks.mark2) || 0,
          total
        }
      ]);

      if (response.status === 200) {
        setModules(updatedModules);
        setEditOpen(false);

        toast.success("Marks updated successfully!");
        await fetchDataFromAPI();
        updatedModules[currentModuleIndex].isEdited = false; // Mark as not edited
        updatedModules[currentModuleIndex].isSubmitted = true; // Mark as submitted
        setModules(updatedModules);
      }
    } catch (error) {
      console.error("Error updating marks:", error);
      toast.error("Error updating marks.");
    }
  };

  const handleModuleSubmit = async (moduleIndex) => {
    const module = modules[moduleIndex];

    if (!module) return;

    const { moduleName, marks } = module;
    if (!marks.mark1) {
      toast.error("Please enter M[50] marks.");
      return;
    }

    if (assignment && !marks.mark2) {
      toast.error("Please enter A marks.");
      return;
    }
    const total = calculateTotal(marks);

    try {
      await axios.post(`registrationadvances/${studentId}/moduleMarks`, [{
        moduleName,
        mark1: parseFloat(marks.mark1) || 0,
        mark2: parseFloat(marks.mark2) || 0,
        total,
        isSubmitted: true // Mark this module as submitted
      }]);

      // Update the module to reflect submission
      const updatedModules = [...modules];
      updatedModules[moduleIndex].isSubmitted = true;
      updatedModules[moduleIndex].isEdited = false; // Reset edited state
      updatedModules[moduleIndex].marks.total = total; // Update the total after submission

      updatedModules[moduleIndex].hasMarks = true;
      setModules(updatedModules);
      toast.success("Module marks submitted successfully!");
      await fetchDataFromAPI();
    } catch (error) {
      console.error("Error submitting module marks:", error);
      toast.error("Failed to submit module marks. Please try again.");
    }
  };


  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await axios.get(`batch/${batchId1}`);
        const moduleDetails = response.data.moduleDetails || [];

        const formattedModules = moduleDetails.map(module => {
          const studentModule = studentData.moduleMarks.find(m => m.moduleName === module.moduleName) || {};
          // const hasMarks = !!(studentModule.mark1 || studentModule.mark2);
          const hasMarks = (studentModule.mark1 !== undefined && studentModule.mark1 !== null) ||
            (studentModule.mark2 !== undefined && studentModule.mark2 !== null);
          return {
            moduleName: module.moduleName,
            marks: {
              mark1: studentModule.mark1,
              mark2: studentModule.mark2,
              total: (parseFloat(studentModule.mark1)) + (parseFloat(studentModule.mark2))
            },
            hasMarks: hasMarks,
            disabled: studentModule.mark1 || studentModule.mark2, // Add a disabled property
            isEdited: false,
            isSubmitted: false // Initialize as false for tracking submission
          };
        });

        setModules(formattedModules);
      } catch (error) {
        console.error('Error fetching module details:', error);
      }
    };

    fetchModules();
  }, [batchId1, studentData]);

  const calculateTotal = (marks) => {
    const mark1 = parseFloat(marks.mark1) || 0;
    const mark2 = parseFloat(marks.mark2) || 0;
    return mark1 + mark2;
  };

  const handleInputChange = (moduleIndex, key, value) => {
    const updatedModules = [...modules];
    updatedModules[moduleIndex].marks[key] = value;
    updatedModules[moduleIndex].isEdited = true;
    const newTotal = calculateTotal(updatedModules[moduleIndex].marks);
    updatedModules[moduleIndex].marks.total = newTotal;

    setModules(updatedModules);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>Module Form</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ flexGrow: 1, padding: 2 }}>
            {assignment ?
              <ModuleFormWithAssignment
                modules={modules}
                handleInputChange={handleInputChange}
                studentData={studentData}
                handleEdit={handleEdit}
                handleModuleSubmit={handleModuleSubmit}
              /> :
              <ModuleFormWithoutAssignment
                modules={modules}
                handleInputChange={handleInputChange}
                studentData={studentData}
                handleEdit={handleEdit}
                handleModuleSubmit={handleModuleSubmit}
              />
            }
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <EditModuleModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        currentMarks={currentMarks}
        handleEditChange={handleEditChange}
        handleEditSubmit={handleEditSubmit}
        showBothFields={assignment}
      />
    </>
  );
};



const App = () => {
  const [open, setOpen] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const { batchId, intakeId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId));
  const intakeId1 = decryptData(decodeURIComponent(intakeId));
  const [assignment, setAssignment] = useState(false);
  const [externalStudents, setExternalStudents] = useState([]);
  const [data, setData] = useState([]);
  const [selectedStudentData, setSelectedStudentData] = useState(null);
  const [editedMarks, setEditedMarks] = useState({});
  const [batch, setBatch] = useState(null);
  const Navigate = useNavigate()
  useEffect(() => {
    fetchDataFromAPI();
    fetchExternalDataFromAPI();
  }, [intakeId1]);


  useEffect(() => {
    fetchExternalDataFromAPI();
    fetchAssignmentCondition();
  }, [batchId1]);


  const fetchDataFromAPI = async () => {
    try {
      const response = await axios.get(`intake/${intakeId1}`);
      const responseData = response.data.students;
      console.log("responseData:", responseData);
      // Format the data to match your table structure
      const formattedData = responseData.reverse().map(student => ({
        studentName: student.studentName,
        nric: student.nric,
        studentId: student.id,
        registrationAdvanceId: student.registrationAdvanceId,
        intakeId: student.intakeId,
        course: student.course,
        moduleMarks: student.moduleMarks.map(module => ({
          moduleName: module.moduleName,
          mark1: module.mark1,
          mark2: module.mark2,
          total: module.mark1 + module.mark2
        }))
      }));
      console.log("Fetched data:", formattedData);
      setData(formattedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };




  const fetchAssignmentCondition = async () => {
    try {
      const response = await axios.get(`batch/${batchId1}`);
      const batchData = response.data;
      console.log("batchData:", batchData);
      setAssignment(batchData.assignment);
      setBatch(batchData);// Use assignment condition from API
    } catch (error) {
      console.error('Error fetching batch assignment condition:', error);
    }
  };

  const fetchExternalDataFromAPI = async () => {
    try {
      const response = await axios.get(`/registrationadvances/intake/${intakeId1}/students`);
      const externalData = response.data;
      setExternalStudents(externalData);
    } catch (error) {
      console.error('Error fetching external data:', error);
    }
  };

  // Pagination logic


  const generateExcel = async () => {
    await fetchDataFromAPI();
    const updatedData = data;

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Student Marks");

    const validCourses = [
      "Diploma in Computer Engineering",
      "Diploma in Hospitality Management",
      "Diploma in Mechanical and Electrical Engineering",
      "Diploma in Electrical and Electronics Engineering"
    ];

    const courseName = updatedData[0]?.course || 'StudentMarks';
    const isValidCourse = batch?.assignment;

    // Get unique module names
    const uniqueModules = Array.from(new Set(updatedData.flatMap(student =>
      student.moduleMarks.map(module => module.moduleName)
    )));

    // Set column headers: S.No, Batch No, Student Name, NRIC/FIN, then module names
    worksheet.columns = [
      { header: "S.No", key: "sno", width: 5, style: { alignment: { horizontal: 'center' } } },
      { header: "Batch No", key: "IntakeId", width: 15, style: { alignment: { horizontal: 'center' } } },
      { header: "Student Name", key: "studentName", width: 33, style: { alignment: { horizontal: 'center' } } },
      { header: "NRIC/FIN", key: "nric", width: 15, style: { alignment: { horizontal: 'center' } } },
      ...uniqueModules.map(moduleName => ({
        header: moduleName,
        key: moduleName,
        width: 20,
        style: { alignment: { horizontal: 'center' } }
      }))
    ];

    // Set the main heading (course name) and apply styles (bold, center, large font size)
    worksheet.mergeCells('A1:' + String.fromCharCode(64 + worksheet.columns.length) + '1');
    const mainHeadingCell = worksheet.getCell('A1');
    mainHeadingCell.value = `${courseName}`;
    mainHeadingCell.style = {
      font: { bold: true, size: 20 },
      alignment: { horizontal: 'center', vertical: 'middle' },
    };
    worksheet.getRow(1).height = 25;
    // Add subheading (column headers) in row 2
    worksheet.getRow(2).values = [
      "S.No", "Batch No", "Student Name", "NRIC/FIN",
      ...uniqueModules
    ];

    // Apply yellow background and bold font to the second row
    worksheet.getRow(2).eachCell((cell) => {
      cell.style = {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } },
        alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
        font: { bold: true }
      };
    });

    // Add each student's row
    updatedData.forEach((student, index) => {
      const moduleTotals = uniqueModules.map(moduleName => {
        const module = student.moduleMarks.find(m => m.moduleName === moduleName) || {};
        const mark1 = module.mark1 || 0;
        const mark2 = module.mark2 || 0;
        return isValidCourse ? mark1 + mark2 : mark1;
      });

      worksheet.addRow([
        index + 1,
        student.intakeId,
        student.studentName.toUpperCase(),
        student.nric,
        ...moduleTotals
      ]);
    });

    // Export the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `${courseName}.xlsx`);
  };



  const handleMarkChange = (e, studentId, moduleName, fieldType) => {
    const newValue = e.target.value;

    // Store changes locally without hitting the API
    setEditedMarks((prev) => ({
      ...prev,
      [`${studentId}-${moduleName}-${fieldType}`]: newValue,
    }));

    // Update state for UI rendering
    setData((prevData) =>
      prevData.map((student) =>
        student.studentId === studentId
          ? {
            ...student,
            moduleMarks: student.moduleMarks.map((module) =>
              module.moduleName === moduleName
                ? { ...module, [fieldType]: newValue }
                : module
            ),
          }
          : student
      )
    );

  };

  const handleMarkBlur = async (registrationAdvanceId, moduleName) => {
    const moduleKey1 = `${registrationAdvanceId}-${moduleName}-mark1`;
    const moduleKey2 = `${registrationAdvanceId}-${moduleName}-mark2`;

    if (!(moduleKey1 in editedMarks) && !(moduleKey2 in editedMarks)) {
      console.log("1");
      return; // No changes, so don't call the API
    }

    const student = data.find((s) => s.registrationAdvanceId === registrationAdvanceId);
    if (!student) return;

    const module = student.moduleMarks.find((m) => m.moduleName === moduleName);

    // Validate Marks
    // if (!editedMarks[moduleKey1] && !module?.mark1) {
    //   //toast.error("Please enter M[50] marks.");
    //   console.log("2");
    //   return;
    // }
    // if (assignment && !editedMarks[moduleKey2] && !module?.mark2) {
    //   //toast.error("Please enter A marks.");
    //   console.log("3");
    //   return;
    // }

    const mark1 = parseFloat(editedMarks[moduleKey1] || module?.mark1);
    const mark2 = parseFloat(editedMarks[moduleKey2] || module?.mark2);
    const total = (isNaN(mark1) ? 0 : mark1) + (isNaN(mark2) ? 0 : mark2);

    try {
      if (module) {
        // **PUT API: Update Existing Marks**
        const response = await axios.put(
          `registrationadvances/marks/${registrationAdvanceId}/moduleMarks1`,
          [{ moduleName, mark1, mark2, total }]
        );

        if (response.status === 200) {
          toast.success("Marks updated successfully!");
        }
      } else {
        // **POST API: Create New Marks**
        const response = await axios.post(
          `registrationadvances/${registrationAdvanceId}/moduleMarks`,
          [{ moduleName, mark1, mark2, total, isSubmitted: true }]
        );

        if (response.status === 200) {
          toast.success("Module marks submitted successfully!");
        }
      }

      await fetchDataFromAPI();
      setEditedMarks((prev) => {
        const updated = { ...prev };
        delete updated[moduleKey1];
        delete updated[moduleKey2];
        return updated;
      });
    } catch (error) {
      console.error("Error submitting marks:", error);
      toast.error("Failed to submit module marks. Please try again.");
    }
  };

  const validCourses = [
    "Diploma in Computer Engineering",
    "Diploma in Hospitality Management ",
    "Diploma in Mechanical and Electrical Engineering",
    "Diploma in Electrical and Electronics Engineering "
  ];
  return (
    <div  >
      <Button variant="contained" color="primary" onClick={generateExcel} style={{ marginBottom: '3px', backgroundColor: buttonBackgroundColor }} startIcon={<DownloadIcon />}>
        Export to Excel
      </Button>
      <br />
      <br />
      <TableContainer
        component={Paper}
        style={{
          boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
          borderRadius: '8px',
          maxHeight: '500px',  // Set a max height for the container
          overflowY: 'auto'   // Enable vertical scrolling for the table body
        }}
      >
        <Table style={{ width: "1290px" }}>
          <TableHead>
            <TableRow
              style={{
                backgroundColor: '#f5f5f5',
                position: 'sticky',
                top: 0,
                zIndex: 1 // Ensures it stays above the table body when scrolling
              }}
            >
              <TableCell style={{ fontWeight: 'bold' }}>S.No</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Student Name</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>NRIC</TableCell>
              {/* {Array.from(new Set(data.flatMap(student =>
      student.moduleMarks.map(module => module.moduleName)
    )))
    .map(moduleName => (
      <TableCell key={moduleName} style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {moduleName}
      </TableCell>
    ))} */}
              {batch?.moduleNames?.map(module => (
                <TableCell key={module.id} style={{ fontWeight: 'bold', textAlign: 'center' }}>
                  {module.moduleName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>


          <TableBody>
            {data.map((student, index) => (
              <TableRow key={index} hover style={{ backgroundColor: '#fafafa' }}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{student.studentName.toUpperCase()}</TableCell>
                <TableCell>{student.nric}</TableCell>

                {batch?.moduleNames?.map((module, moduleIndex, moduleArray) => {
                  const moduleName = module.moduleName;

                  // Find the student's marks for this module
                  const studentModule = student.moduleMarks.find(m => m.moduleName === moduleName);

                  // Get previous module name

                  const isValidCourse = batch?.assignment;

                  // Get previous module
                  const prevModule = moduleArray[moduleIndex - 1];
                  const prevModuleName = prevModule?.moduleName;

                  const prevM = editedMarks[`${student.registrationAdvanceId}-${prevModuleName}-mark1`] ??
                    student.moduleMarks.find(m => m.moduleName === prevModuleName)?.mark1;

                  const prevA = isValidCourse
                    ? editedMarks[`${student.registrationAdvanceId}-${prevModuleName}-mark2`] ??
                    student.moduleMarks.find(m => m.moduleName === prevModuleName)?.mark2
                    : true;

                  // Current M and A
                  const currentM = editedMarks[`${student.registrationAdvanceId}-${moduleName}-mark1`] ??
                    studentModule?.mark1;

                  const allowM = moduleIndex === 0 || (prevM && prevA);
                  const allowA = isValidCourse && !!currentM;

                  return (
                    <TableCell key={moduleName} style={{ textAlign: 'center' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                          position: 'relative',

                          gap: '7px', // spacing between E and A sections
                        }}
                      >
                        {/* E MARK */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <div style={{ marginBottom: '5px' }}>E</div>
                          <TextField
                            type="number"
                            variant="outlined"
                            size="small"
                            value={editedMarks[`${student.registrationAdvanceId}-${moduleName}-mark1`] ?? studentModule?.mark1 ?? ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              const numValue = Number(value);
                              const maxE = batch?.assignment ? 50 : 100;
                              if (value !== "" && (isNaN(numValue) || numValue > maxE || numValue < 0)) {
                                toast.error(`Maximum marks allowed for E is ${maxE}.`);
                                e.target.value = '';
                                return;
                              }
                              handleMarkChange(e, student.registrationAdvanceId, moduleName, "mark1");
                            }}
                            onBlur={() => handleMarkBlur(student.registrationAdvanceId, moduleName)}
                            style={{ width: '60px' }}
                            inputProps={{
                              min: 0,
                              max: batch?.assignment ? 50 : 100,
                            }}
                          />
                        </div>

                        {/* A MARK + TOTAL (only if E is filled) */}
                        {batch?.assignment && !isNaN(currentM) && currentM >= 0 && currentM <= 50 && (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div style={{ marginBottom: '5px' }}>A</div>
                            <TextField
                              type="number"
                              variant="outlined"
                              size="small"
                              value={editedMarks[`${student.registrationAdvanceId}-${moduleName}-mark2`] ?? studentModule?.mark2 ?? ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                const numValue = Number(value);
                                if (value !== "" && (isNaN(numValue) || numValue > 50 || numValue < 0)) {
                                  toast.error("Maximum marks allowed for A is 50.");
                                  e.target.value = '';
                                  return;
                                }
                                handleMarkChange(e, student.registrationAdvanceId, moduleName, "mark2");
                              }}
                              onBlur={() => handleMarkBlur(student.registrationAdvanceId, moduleName)}
                              style={{ width: '60px', marginBottom: '5px' }}
                              disabled={!allowA}
                              inputProps={{ min: 0, max: 50 }}
                            />

                            {/* Total */}
                            {(() => {
                              const mark1 = Number(editedMarks[`${student.registrationAdvanceId}-${moduleName}-mark1`] ?? studentModule?.mark1);
                              const mark2 = Number(editedMarks[`${student.registrationAdvanceId}-${moduleName}-mark2`] ?? studentModule?.mark2);
                              if (!isNaN(mark1) && !isNaN(mark2)) {
                                return (
                                  <div style={{
                                    display: 'flex', alignItems: 'center', gap: '4px', left: '50%',
                                    transform: 'translateX(-60%)',
                                    textAlign: 'center',
                                  }}>
                                    <strong>Total:</strong>
                                    <span style={{ fontWeight: "bold" }}>{mark1 + mark2}</span>
                                  </div>
                                );
                              }
                              return null;
                            })()}
                          </div>
                        )}
                      </div>
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


      <ModuleForm open={open} onClose={() => setOpen(false)} studentId={selectedStudentId} assignment={assignment} studentData={selectedStudentData} fetchDataFromAPI={fetchDataFromAPI} />
      <ToastContainer />
    </div>

  );
};

export default App;

